<template>
  <div class="yes-no-choice">
    <button type="radio" class="yes" :class="{ active: state }" @click="setState(true)">Ja</button>
    <button type="radio" class="no" :class="{ active: !state }" @click="setState(false)">Nei</button>
  </div>
</template>

<script>
export default {
  name: "YesNoChoice",
  props: {
    initialState: Boolean,
  },
  data() {
    return {
      state: false,
    };
  },
  mounted() {
    this.state = this.initialState;
  },
  methods: {
    setState(newState) {
      this.state = newState;
      this.$emit("change", this.state);
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background-color: white;
  color: inherit;
  padding: 10px;
  border: 1px solid #d6d6d6;
  text-transform: uppercase;
  margin: 0;
  font-weight: 500;
}

.active.yes {
  background-color: #5cb85c;
  color: white;
}

.active.no {
  background-color: #C4C4C4;
  color: white;
}
</style>